var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "bizScopeForm",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.bizScope, rules: _vm.bizScopeRules }
    },
    [
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("业务范围名称")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x",
                    attrs: { type: "text", "auto-complete": "off" },
                    model: {
                      value: _vm.bizScope.name,
                      callback: function($$v) {
                        _vm.$set(_vm.bizScope, "name", $$v)
                      },
                      expression: "bizScope.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("描述")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "desc" } },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "请输入描述"
                    },
                    model: {
                      value: _vm.bizScope.desc,
                      callback: function($$v) {
                        _vm.$set(_vm.bizScope, "desc", $$v)
                      },
                      expression: "bizScope.desc"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("使用范围")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("业务单元类型")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "comLevel" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.bizScope.bizUnitType,
                        callback: function($$v) {
                          _vm.$set(_vm.bizScope, "bizUnitType", $$v)
                        },
                        expression: "bizScope.bizUnitType"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: 3 } },
                        [_vm._v("总部")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: 0 } },
                        [_vm._v("普通")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: 1 } },
                        [_vm._v("门店")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7caf0091", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7caf0091","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/MerchtBizPermScopeSave.vue
// module id = 3484
// module chunks = 0